<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconWarning_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.278 12.867c0 .626-.507 1.133-1.133 1.133h-.012a1.133 1.133 0 1 1 0-2.267h.012c.626 0 1.133.508 1.133 1.134m-1.133-3.4A1.133 1.133 0 0 1 7.01 8.333v-5.2a1.133 1.133 0 0 1 2.267 0v5.2c0 .626-.507 1.134-1.133 1.134"
        clip-rule="evenodd"
    />
</svg>
